import * as React from 'react'
import '../css/simpleList.css'
import {useTranslation} from 'react-i18next'
import { locales } from '../util/locales'

interface Block {
    title?: string
    textList?: string[]
    img?: string
}

interface SimpleListProps {
    bordered?: boolean
    blocks: Block[]
}

const SimpleList = (props: SimpleListProps) => {
    const {i18n} = useTranslation('landing')
    const ja = i18n.language.includes(locales.ja)

    const renderText = (textList) => textList.map((text, index) => <p key={'text-p-' + index}>{text}</p>)

    const renderBlock = (block: Block, i) => (
        <div key={'item-' + i} className="list-item">
            <div className={props.bordered ? 'rectangle-100 bordered' : 'rectangle-80'}><img src={block.img}/></div>
            <div className="content-block">
                <div className="block-p">{block.title}</div>
                <div className="block-c" style={ja ? {width: '100%'} : {}} >{renderText(block.textList)}</div>
            </div>
        </div>
    )

    const renderList = () => props.blocks.map((block: any, index) => renderBlock(block, index + 1))

    return <div className="simple-list-container">{renderList()}</div>
}

export default SimpleList



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/simpleList.tsx